// extracted by mini-css-extract-plugin
export default {"modalOverlay":"MC-z","modalContent":"NC-z","header":"OC-z","close":"PC-z"};